import { SchedulableAction } from "src/pages/FleetManagement/pages/ViewProgram/AlenScheduling/types";
import { ProgramDisplay } from "./IProgramDisplay";
import { Schedule, OneTimeSchedule, RecurringSchedule } from "./ISchedule";

export enum ProgramType {
  TURBO_MODE = "TURBO_MODE",
  MODE_CHANGE = "MODE_CHANGE",
  REGULAR = "REGULAR",
}

export interface Program<ProgramTypeValue extends ProgramType = ProgramType> {
  program_id: number;
  program_name: string;
  program_type: ProgramType;
  schedules: Array<
    ProgramTypeValue extends ProgramType.TURBO_MODE | ProgramType.MODE_CHANGE
      ? OneTimeSchedule
      : ProgramTypeValue extends ProgramType.REGULAR
      ? RecurringSchedule
      : Schedule
  >;
  program_displays: Array<ProgramDisplay>;
  devices: Array<{
    device_id: string;
  }>;
}

export type RegularProgram = Program<ProgramType.REGULAR>;

export type AlenScheduleDays =
  | "SUNDAY"
  | "MONDAY"
  | "TUESDAY"
  | "WEDNESDAY"
  | "THURSDAY"
  | "FRIDAY"
  | "SATURDAY";
export type AlenScheduleFrequncy = {
  repeat: "DAILY";
  days: AlenScheduleDays[];
};

export type AlenScheduleDeviceGroup = {
  deviceGroupName: string;
  deviceDetails: {
    productId: string;
    deviceIds: string[];
  }[];
};

export type AlenSchedule = {
  deviceSchedulerId: number;
  enabled: boolean;
  cancelNextRun: boolean;
  nextOccurrenceLabel: string;
  nextOccurrenceValue: string;
  nextOccurrenceDate: string;
  schedulerType: "BULK" | "INDIVIDUAL";
  schedulerName: string;
  schedulerCode: string;
  timezone: string;
  timezoneId: string;
  actionStartTime: string;
  actionEndTime?: string;
  actionCode: keyof SchedulableAction;
  actionStartValue: SchedulableAction[keyof SchedulableAction];
  actionEndValue?: SchedulableAction[keyof SchedulableAction];
  frequency: AlenScheduleFrequncy;
  deviceGroupType: "PRODUCT_NAME";
  deviceGroups: AlenScheduleDeviceGroup[];
};

export const frequencyDays: { label: string; value: AlenScheduleDays }[] = [
  { label: "S", value: "SUNDAY" },
  { label: "M", value: "MONDAY" },
  { label: "T", value: "TUESDAY" },
  { label: "W", value: "WEDNESDAY" },
  { label: "T", value: "THURSDAY" },
  { label: "F", value: "FRIDAY" },
  { label: "Sa", value: "SATURDAY" },
];
